/**
 * Integrations panel — warm design tokens (2026-08-18 UX overhaul).
 *
 * One place for the page's palette and shape language. Values collected from
 * the constants that were previously inlined across IntegrationsPanel.tsx,
 * AppAccessSheet.tsx, and connectApp.ts (PREST0_GOLD et al) — the standing
 * directive is warm ink + gold, never blue. Keep chat's card constants
 * (connectApp.ts) in sync when changing these.
 */

import type * as React from 'react';

export const panelTheme = {
  // Core warm palette
  gold: 'var(--brand-gold)',
  goldDeep: 'var(--brand-gold-hover)',
  ink: '#1C1917',
  inkSoft: '#241c10',
  inkMuted: '#6B6459',
  inkFaint: 'var(--brand-text-muted)',
  goldInk: '#6b5d3f',
  surface: '#FAF8F3',
  surfaceGoldTint: 'rgba(198, 167, 94, 0.07)',
  goldTint: 'rgba(198, 167, 94, 0.14)',
  goldTintStrong: 'rgba(198, 167, 94, 0.15)',
  border: '#E7DCC3',
  borderSoft: '#E5E0D5',
  borderFaint: '#EFEAE0',
  chipBg: '#F1E9D8',

  // Neutral grays (secondary text, skeletons, disabled)
  grayBorder: '#E5E7EB',
  grayBg: '#F3F4F6',
  grayText: '#6B7280',
  grayFaint: '#9CA3AF',
  graySlate: '#4B5563',

  // Status
  success: '#16A34A',
  successDeep: '#15803D',
  successBg: '#F0FDF4',
  successBorder: '#D1FAE5',
  successChip: '#DCFCE7',
  danger: '#DC2626',
  dangerSoft: '#A83232',
  dangerBg: '#FEF2F2',
  dangerBorder: '#FCA5A5',

  // Shape
  radiusCard: '10px',
  radiusModal: '14px',
  radiusChip: '12px',
  radiusPill: '999px',
  radiusInput: '8px',

  // Elevation
  shadowPopover: '0 6px 18px rgba(30, 25, 10, 0.14)',
  shadowModal: '0 18px 50px rgba(28, 25, 23, 0.25)',
  overlayScrim: 'rgba(28, 25, 23, 0.45)',
} as const;

/** Focus ring for keyboard users — warm gold, never the browser default blue. */
export const focusRingStyle: React.CSSProperties = {
  outline: `2px solid ${panelTheme.gold}`,
  outlineOffset: '2px',
};

export default panelTheme;
